
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./interval.cjs.production.min.js')
} else {
  module.exports = require('./interval.cjs.development.js')
}
